import { useEffect, useState, useContext } from 'react';
import { useTranslation } from 'next-i18next';

import { locationTranslation } from '@spa/shared/utils/location';
import { LocationContext } from '@spa/shared/contexts/location';
import { languageToLocale } from '@spa/shared/utils/language';
import { CITIES } from '@spa/shared/constants/locationTypes';

const INITIAL_CITY_STATE = {
  metadata: { name_translations: { items: [] } },
  _embedded: { country: { metadata: { name_translations: { items: [] } }, configuration: { slug: '' } } }
};

const getTranslationFromLocation = (language, location) => {
  const locale = languageToLocale(language);
  return locationTranslation(location, locale);
};

const getCityFromLocation = ({ type, city, ...location }) => {
  if (type === CITIES) {
    return location;
  }

  return city;
};

export const useCityLocation = () => {
  const {
    i18n: { language }
  } = useTranslation();
  const [location, setLocation] = useContext(LocationContext);
  const initialTranslation = location ? getTranslationFromLocation(language, location) : '';
  const initialCity = location ? getCityFromLocation(location) : INITIAL_CITY_STATE;

  const [translation, setTranslation] = useState(initialTranslation);
  const [city, setCity] = useState(initialCity);

  useEffect(() => {
    if (!location) {
      return;
    }

    setTranslation(getTranslationFromLocation(language, location));
    setCity(getCityFromLocation(location));
  }, [location, language]);

  return { city, translation, location, setLocation };
};
